import React, { useState } from 'react';
import { BuildingIcon, TruckIcon, HardHatIcon, UserIcon, DollarSignIcon, HandshakeIcon, LogOutIcon, ShieldIcon, ChevronDownIcon, XIcon } from 'lucide-react';
interface SidebarProps {
  currentRole: string;
  setCurrentRole: (role: string) => void;
  onLogout: () => void;
  isAdmin?: boolean;
  isOpen?: boolean;
  onClose?: () => void;
}
export const Sidebar = ({
  currentRole,
  setCurrentRole,
  onLogout,
  isAdmin = false,
  isOpen = true,
  onClose
}: SidebarProps) => {
  const [roleSwitcherOpen, setRoleSwitcherOpen] = useState(false);
  const roles = [{
    id: 'contractor',
    name: 'Contractor',
    icon: <BuildingIcon size={20} data-id="element-90" />
  }, {
    id: 'broker',
    name: 'Broker',
    icon: <HandshakeIcon size={20} data-id="element-91" />
  }, {
    id: 'foreman',
    name: 'Foreman',
    icon: <HardHatIcon size={20} data-id="element-92" />
  }, {
    id: 'trucking',
    name: 'Trucking Co.',
    icon: <TruckIcon size={20} data-id="element-93" />
  }, {
    id: 'driver',
    name: 'Driver',
    icon: <UserIcon size={20} data-id="element-94" />
  }, {
    id: 'factoring',
    name: 'Factoring',
    icon: <DollarSignIcon size={20} data-id="element-95" />
  }, {
    id: 'admin',
    name: 'Admin',
    icon: <ShieldIcon size={20} data-id="element-96" />
  }];
  // Get current role data
  const currentRoleData = roles.find(role => role.id === currentRole);
  return <>
      {/* Overlay - visible on all screen sizes when sidebar is open */}
      <div className={`fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} onClick={onClose} data-id="element-97" />
      {/* Sidebar - now toggleable on all screen sizes */}
      <div className={`fixed inset-y-0 left-0 z-50 w-64 bg-[#0F2A52] text-white p-4 flex flex-col h-screen transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full'}`} data-id="element-98">
        {/* Close Button - visible on all screen sizes */}
        <button onClick={onClose} className="absolute top-4 right-4 text-white hover:text-gray-300" aria-label="Close sidebar" data-id="element-99">
          <XIcon size={24} data-id="element-100" />
        </button>
        <div className="text-xl font-bold mb-8 mt-4 pr-8 text-center" data-id="element-101">
          DirtLogics
        </div>
        {/* Role Display with Switcher for Admins - moved down and centered */}
        <div className="my-8" data-id="element-102">
          <div className="text-sm text-blue-300 mb-2 text-center" data-id="element-103">
            Logged in as:
          </div>
          {isAdmin ? <div className="relative" data-id="element-104">
              <button onClick={() => setRoleSwitcherOpen(!roleSwitcherOpen)} className="w-full flex items-center justify-between px-3 py-2 bg-[#0F2A52]/70 hover:bg-[#0F2A52]/90 rounded-md border border-blue-700" data-id="element-105">
                <div className="flex items-center gap-3" data-id="element-106">
                  {currentRoleData?.icon}
                  <span data-id="element-107">{currentRoleData?.name}</span>
                </div>
                <ChevronDownIcon size={16} className={`transition-transform ${roleSwitcherOpen ? 'rotate-180' : ''}`} data-id="element-108" />
              </button>
              {/* Role Switcher Dropdown */}
              {roleSwitcherOpen && <div className="absolute left-0 right-0 mt-1 bg-[#0F2A52] rounded-md shadow-lg overflow-hidden z-10 border border-blue-700" data-id="element-109">
                  <div className="py-1" data-id="element-110">
                    <div className="px-3 py-2 text-xs text-blue-300 border-b border-blue-800" data-id="element-111">
                      Switch Role
                    </div>
                    {roles.map(role => <button key={role.id} className={`w-full text-left px-3 py-2 flex items-center gap-3 hover:bg-[#0F2A52]/70 ${currentRole === role.id ? 'bg-[#0F2A52]/50' : ''}`} onClick={() => {
                setCurrentRole(role.id);
                setRoleSwitcherOpen(false);
              }} data-id="element-112">
                        {role.icon}
                        <span data-id="element-113">{role.name}</span>
                      </button>)}
                  </div>
                </div>}
            </div> : <div className="flex items-center justify-center gap-3 px-3 py-2 bg-[#0F2A52]/70 rounded-md border border-blue-700" data-id="element-114">
              {currentRoleData?.icon}
              <span data-id="element-115">{currentRoleData?.name}</span>
            </div>}
          {isAdmin && <div className="mt-2 text-xs px-3 py-1 bg-[#F58220] rounded-md text-center font-medium" data-id="element-116">
              Admin Access
            </div>}
        </div>
        <div className="space-y-1" data-id="element-117">
          {/* Menu items would go here based on the role */}
        </div>
        <div className="mt-auto pt-6" data-id="element-118">
          <button className="w-full flex items-center gap-3 px-3 py-2 rounded-md text-left hover:bg-[#0F2A52]/70 transition-colors" onClick={onLogout} data-id="element-119">
            <LogOutIcon size={20} data-id="element-120" />
            <span data-id="element-121">Logout</span>
          </button>
        </div>
      </div>
    </>;
};